import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const HelpIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M12 4.012A7.988 7.988 0 1019.988 12 8.012 8.012 0 0012 4.012zm0 9.985A1.997 1.997 0 1113.997 12 2.003 2.003 0 0112 13.997zm0-7.988a5.825 5.825 0 012.596.6l-1.554 1.553a3.586 3.586 0 00-2.085 0L9.404 6.608A5.825 5.825 0 0112 6.01zM6.009 12a5.825 5.825 0 01.6-2.596l1.553 1.554a3.586 3.586 0 000 2.085l-1.554 1.553A5.825 5.825 0 016.01 12zM12 17.99a5.825 5.825 0 01-2.596-.598l1.554-1.554a3.586 3.586 0 002.085 0l1.553 1.554A5.825 5.825 0 0112 17.99zm5.392-3.394l-1.554-1.554a3.586 3.586 0 000-2.085l1.554-1.553a5.924 5.924 0 010 5.192z" />
  </SvgIcon>
);
HelpIcon.displayName = 'HelpIcon';
HelpIcon.muiName = 'SvgIcon';

export default HelpIcon;
